import { navigate } from "gatsby-link"
import React from "react"
import { useForm } from "react-hook-form"

import Input from "../form/Input"

export default function BookBar({ name, link, imgSrc }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm({
    // defaultValues: {
    //   start: addDays(new Date(), 14),
    //   end: addDays(new Date(), 21),
    //   adults: 4,
    //   children: 2,
    // },
  })
  const onSubmit = data => {
    // const searchData = {
    //   ...data,
    //   start: format(data.start, "dd-MM-yyyy"),
    //   end: format(data.end, "dd-MM-yyyy"),
    // }
    const queryString = Object.keys(data)
      .map(key => key + "=" + data[key])
      .join("&")

    navigate(`${link}${name}&${queryString}&image=${imgSrc}`)
  }

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="w-5/6 ml-auto mt-auto h-auto lg:h-24 bg-white bg-opacity-75 mb-[40px] mr-[40px] self-end pl-6 pr-4 py-4"
    >
      <div className=" grid grid-cols-2 gap-4 sm:gap-8 lg:gap-0 lg:flex space-x-0 lg:space-x-6 items-center justify-between">
        <Input
          label="Booking Date"
          type="Date"
          className="w-full lg:w-40"
          field="date"
          register={register}
        />

        <Input
          select
          label="Passengers"
          type="Select"
          className="w-full lg:w-24"
          options={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]}
          field="passengers"
          register={register}
        />

        <button
          type="submit"
          className="col-span-2 h-full w-full lg:w-44 py-5 flex justify-center items-center bg-black text-white font-bold text-sm outline-focus focus:outline-none"
        >
          Book Now
        </button>
      </div>
    </form>
  )
}
